import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetReasonForReferenceDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReasonForReference/GetDetail?` + params, null);

export const GetReasonForReferenceList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReasonForReference/GetList?` + params, null);

export const CreateReasonForReference = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReasonForReference/Create`, data);

export const UpdateReasonForReference = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReasonForReference/Update`, data);

export const DeleteReasonForReference = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ReasonForReference/Delete`, data);